<template>
  <div id="main-content" style="display: flex;flex-flow: row">
    <a-card title="比例"
            style="flex: 1;overflow-y: hidden;border-radius: 5px"
            :bodyStyle="{padding:'0',overflowY:'scroll',height: 'calc(100% - 65px)'}">
      <div slot="extra">
        <a-radio-group button-style="solid" v-model="cate" @change="changeDate">
          <a-radio-button value="">
            全部
          </a-radio-button>
          <a-radio-button value="game">
            游戏
          </a-radio-button>
          <a-radio-button value="ai">
            AI
          </a-radio-button>
        </a-radio-group>
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="changeDate()"/>         
      </div>
      <a-table :columns="tableColumns" id="show-table"
               style="height: 100%;overflow-y: hidden;background: #ffffff"
               :scroll="{ y: _get_table_scroll({id:'show-table',extraHeight:60}) }"
               :rowKey="item=>item.date" :loading="tableLoad"
               :data-source="tableData" bordered :pagination="false">
        <template slot="rote" slot-scope="text,recode">
          {{ Math.round(recode.spend * 10000 / allSpend) / 100 }}
        </template>
        <template slot="real_rate" slot-scope="text,recode">
          <a :style="{color:text!=0?'#ff4d4f':'#000'}">{{ text }}</a>
          {{!recode.is_get?"维":""}}
        </template>
        <template slot="footer" slot-scope="currentPageData">
          <div style="display: flex;text-align: center">
            <div style="flex: 1">总计</div>
            <div style="flex: 1;border-left: 1px solid #e8e8e8;border-right: 1px solid #e8e8e8;">
              {{ Math.round(allSpend * 100) / 100 }}
            </div>
            <div style="flex: 1"></div>
          </div>
        </template>
      </a-table>
    </a-card>
    <div id="spend-channel-map"
         style="background: #ffffff;height: 100%;flex: 1;padding: 10px;margin-left:10px;border-radius: 10px;"></div>
  </div>
</template>

<script>
import {GetSpendChannel} from "../../api/v1/spend_api";

export default {
  name: "Channel",
  data() {
    return {
      date: ['', ''],
      cate: '',
      tableColumns: [],
      tableLoad: false,
      tableData: [],
      allSpend: 0,
      spendChannelMap: undefined,
    }
  },
  mounted() {
    this.changeDate()
  },
  methods: {
    changeDate() {
      this.tableColumns = [
        {title: '渠道', dataIndex: 'channel', width: '100px', align: 'center'},
        {title: '拉取消耗', dataIndex: 'spend', width: '100px', align: 'center', sorter: (a, b) => a.spend - b.spend},
        {
          title: '比例', dataIndex: 'rote', width: '100px', align: 'center',
          sorter: (a, b) => a.spend - b.spend,
          scopedSlots: {customRender: 'rote'},
        },
        {title: '上报消耗', dataIndex: 'real_spend', width: '100px', align: 'center'},
        {
          title: '误差(%)', dataIndex: 'real_rate', width: '100px', align: 'center',
          sorter: (a, b) => a.real_rate - b.real_rate, scopedSlots: {customRender: 'real_rate'},
        },
      ]
      GetSpendChannel({
        start: this.date[0],
        end: this.date[1],
        cate: this.cate
      }).then(resp => {
        this.date = resp.data.date
        this.tableData = []
        this.allSpend = 0
        let _channel_data = []
        let _list = resp.data.list
        _list.sort((a, b) => b.spend - a.spend)
        let channelList = this.$store.getters.getSpendChannel.map(item => item.value)
        _list.forEach(item => {
          this.allSpend += item.spend
          this.tableData.push({
            channel: item.channel,
            spend: item.spend,
            real_spend: item.real_spend,
            real_rate: item.real_rate,
            is_get: channelList.includes(item.channel),
            rate: 0,
          })
          _channel_data.push({
            name: item.channel,
            value: item.spend
          })
        })
        let _channel = {
          title: {text: '渠道消耗占比',},
          tooltip: {trigger: 'item', formatter: "{b} : {c} ({d}%)"},
          legend: {right: 0, left: 150, type: 'scroll',},
          series: [{
            name: 'Access From', type: 'pie', radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {borderRadius: 10, borderColor: '#fff', borderWidth: 2},
            label: {show: false, position: 'center'},
            emphasis: {label: {show: true, fontSize: '30', fontWeight: 'bold'}},
            labelLine: {show: false},
            data: _channel_data
          }
          ]
        }
        this.spendChannelMap = this.$echarts.init(document.getElementById('spend-channel-map'))
        this.spendChannelMap.setOption(_channel)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Spend/Channel.vue